'use client'

import PageError from '@/views/shared/error/page-error'

const ErrorPage = () => {
  return <PageError />
}

export default ErrorPage
